var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 *
 * ApexOnlineMenuData Service Reducer
 *
 */
import { MENU_PERMISSIONS_ERROR, MENU_PERMISSIONS_REQUEST, MENU_PERMISSIONS_SUCCESS } from './constants';

var initialState = {
  menuPermissions: {},
  error: null
};

var createMenuPermissionsRequest = function createMenuPermissionsRequest(state) {
  return _extends({}, state);
};
var createMenuPermissionsSuccess = function createMenuPermissionsSuccess(state, action) {
  return _extends({}, state, {
    menuPermissions: action.results
  });
};
var createMenuPermissionsError = function createMenuPermissionsError(state, action) {
  return _extends({}, state, {
    error: action.err
  });
};

export default function reducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case MENU_PERMISSIONS_REQUEST:
      return createMenuPermissionsRequest(state, action.params);
    case MENU_PERMISSIONS_SUCCESS:
      return createMenuPermissionsSuccess(state, action);
    case MENU_PERMISSIONS_ERROR:
      return createMenuPermissionsError(state, action);
    default:
      return state;
  }
}